// Helpers d'affichage member_type.
//
// IMPORTANT : la source de vérité métier reste le BACKEND
// (backend/config/memberTypeConfig.js, servi via /me/entitlements →
// memberTypeConfig.labels/available/default/badgeColors/selfDeclarableTypes).
// Ce fichier ne traduit QUE l'affichage des labels, sans toucher à la logique.
//
// Deux familles de labels :
//   1. getMemberTypeLabel(orgType, type, t, fallbackLabels)
//      → libellé métier précis, variant par org_type (fiche, modal admin,
//        verify-profile). Clé i18n : business:member_type.<orgType>.<type>.
//        Fallback = label backend (memberTypeConfig.labels), puis le type brut.
//   2. getMemberTypeShortLabel(type, t)
//      → libellé court générique (org_type-agnostic) pour les filtres Map
//        (dropdown + chips). Clé i18n : business:member_type_short.<type>.
//
// Si tu ajoutes un type/org_type : propage backend/config/memberTypeConfig.js
// + business.json (member_type + member_type_short).

// Fallback FR court (data-safe) : utilisé hors React ou si `t` absent.
// Ex-duplication MEMBER_TYPE_LABELS de MapFilterBar.js + useMapFilters.js,
// centralisée ici.
export const MEMBER_TYPE_SHORT_LABELS = {
  student: 'Étudiant',
  alumni: 'Alumni',
  member: 'Membre',
  external: 'Externe',
  professor: 'Enseignant(e)',
}

// Label métier précis d'un member_type, variant par org_type.
// `fallbackLabels` = memberTypeConfig.labels (backend FR) — filet data-safe si
// la clé i18n n'existe pas (org_type/type inconnu côté front).
export const getMemberTypeLabel = (orgType, type, t, fallbackLabels) => {
  if (!type) return ''
  const backendFallback = (fallbackLabels && fallbackLabels[type]) || type
  if (t) {
    return t(`business:member_type.${orgType || 'default'}.${type}`, {
      defaultValue: backendFallback,
    })
  }
  return backendFallback
}

// Label court générique (filtres Map). `t` optionnel → fallback FR court.
export const getMemberTypeShortLabel = (type, t) => {
  if (!type) return ''
  if (t) return t(`business:member_type_short.${type}`, { defaultValue: MEMBER_TYPE_SHORT_LABELS[type] || type })
  return MEMBER_TYPE_SHORT_LABELS[type] || type
}
